import React, { ChangeEvent } from 'react';
import { Box, Text, Checkbox } from '@chakra-ui/core';
import { useTranslation } from 'react-i18next';
import { useSeekersFilters } from '../filters/SeekersFiltersContext';
import { SearchAndSortProps } from './searchAndSortType';

export const FavoriteCandidateView = ({ tempSearchAndSortType, setTempSearchAndSortTypes }: SearchAndSortProps): JSX.Element => {
  const { t } = useTranslation();
  const { setIsFromSearchAndSort } = useSeekersFilters();

  const onHandleFavourite = (isFavouriteApplied: boolean) => {
    // searchAndSortTypes.isFavouriteApplied = isFavouriteApplied;
    const updatedFilters = {
      ...tempSearchAndSortType,
      isFavouriteApplied,
    };
    setIsFromSearchAndSort(true);
    setTempSearchAndSortTypes(updatedFilters);
  };
  return (
    <Box>
      <Checkbox
        data-testid="favoriteCheckBox"
        isChecked={tempSearchAndSortType.isFavouriteApplied}
        onChange={(e: ChangeEvent<HTMLInputElement>) => onHandleFavourite(e.target.checked)}
      >
        <Text
          px={3}
          style={{
            fontSize: '14px',
            fontWeight: 'normal',
          }}
        >
          {t('favoriteCandidate.favoriteCandidate')}
        </Text>
      </Checkbox>
    </Box>
  );
};
